import { render, staticRenderFns } from "./UniRequest.vue?vue&type=template&id=51b3595e&"
import script from "./UniRequest.vue?vue&type=script&lang=js&"
export * from "./UniRequest.vue?vue&type=script&lang=js&"
import style0 from "./UniRequest.vue?vue&type=style&index=0&id=51b3595e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports